const API_BASE = 'https://api.dev.auxo.dk/public/content'

async function requestJson(url) {
  const response = await fetch(url, { headers: { Accept: 'application/json' } })
  if (!response.ok) {
    throw new Error(`CMS request failed: ${response.status}`)
  }
  return response.json()
}

export function fetchCollection(collectionName) {
  return requestJson(`${API_BASE}/${collectionName}`)
}

export function fetchCollectionById(collectionName, entryId) {
  return requestJson(`${API_BASE}/${collectionName}/${entryId}`)
}
